import { CssRender } from 'css-render';
const { c } = CssRender();
export { c };
export const cssrAnchorMetaName = 'vueuc-style';
